// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuListDropdownItem-module-item {
  /* Styles for the list item */
}

.MenuListDropdownItem-module-children > .MenuList-module-list {
  gap: 0;
}

.MenuListDropdownItem-module-children > .MenuList-module-list > li {
  border-radius: 0;
  border-top: none;
}

.MenuListDropdownItem-module-children > .MenuList-module-list > li:last-of-type {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.MenuListDropdownItem-module-toggle {
  margin: 0;
  padding: 15px;
  border-radius: 5px;
  background-color: var(--secondary-button-background);
  color: inherit;
  display: flex;
  opacity: 0.7;
  transition: 0.1s;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  position: relative;
}

.MenuListDropdownItem-module-toggle > section {
  display: flex;
  gap: 15px;
  align-items: center;
}

.MenuListDropdownItem-module-iconContainer {
  display: flex;
  align-items: center;
  gap: 15px;
}

.MenuListDropdownItem-module-iconContainer svg {
  width: 30px;
  height: 30px;
  fill: var(--text);
  flex-shrink: 0;
}

.MenuListDropdownItem-module-toggle:hover {
  opacity: 1;
}

.MenuListDropdownItem-module-toggle.MenuListDropdownItem-module-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.MenuListDropdownItem-module-toggle.MenuListDropdownItem-module-open > svg {
  rotate: -180deg;
}

.MenuListDropdownItem-module-toggle > svg {
  width: 30px;
  height: 30px;
  fill: var(--text);
  transition: 0.1s;
  flex-shrink: 0;
}

.MenuListDropdownItem-module-information {
  display: flex;
  flex-direction: column;
}

.MenuListDropdownItem-module-information > span {
  color: var(--text-bold);
}

.MenuListDropdownItem-module-information > p {
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/menu-list-items/MenuListDropdownItem/MenuListDropdownItem.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,oDAAoD;EACpD,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".item {\r\n  /* Styles for the list item */\r\n}\r\n\r\n.children > :global(.MenuList-module-list) {\r\n  gap: 0;\r\n}\r\n\r\n.children > :global(.MenuList-module-list) > li {\r\n  border-radius: 0;\r\n  border-top: none;\r\n}\r\n\r\n.children > :global(.MenuList-module-list) > li:last-of-type {\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\n.toggle {\r\n  margin: 0;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  background-color: var(--secondary-button-background);\r\n  color: inherit;\r\n  display: flex;\r\n  opacity: 0.7;\r\n  transition: 0.1s;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  z-index: 2;\r\n  position: relative;\r\n}\r\n\r\n.toggle > section {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n}\r\n\r\n.iconContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.iconContainer svg {\r\n  width: 30px;\r\n  height: 30px;\r\n  fill: var(--text);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.toggle:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.toggle.open {\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.toggle.open > svg {\r\n  rotate: -180deg;\r\n}\r\n\r\n.toggle > svg {\r\n  width: 30px;\r\n  height: 30px;\r\n  fill: var(--text);\r\n  transition: 0.1s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.information {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.information > span {\r\n  color: var(--text-bold);\r\n}\r\n\r\n.information > p {\r\n  font-size: 0.9rem;\r\n}"],"sourceRoot":""}]);
// Exports
export var item = `MenuListDropdownItem-module-item`;
export var children = `MenuListDropdownItem-module-children`;
export var toggle = `MenuListDropdownItem-module-toggle`;
export var iconContainer = `MenuListDropdownItem-module-iconContainer`;
export var open = `MenuListDropdownItem-module-open`;
export var information = `MenuListDropdownItem-module-information`;
export default ___CSS_LOADER_EXPORT___;
